module.exports = __webpack_public_path__ + "img/thumbnail_AfricanCrestedPorcupine_f_albino.d7e1c329.png";